import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../basic-ui-components/icon/svg-icon/svg.icon';

export class HistoryIcon extends React.Component<ISvgIconProps, {}> {
    render() {
        return <SvgIcon {...this.props} viewBox="0 0 24 24" >
            <g fill="currentColor">
            <path d="M14.512,15.929c0.192-0.024,0.371-0.126,0.49-0.28l0.539-0.692c0.09-0.143,0.126-0.312,0.105-0.482
                c-0.024-0.192-0.126-0.371-0.279-0.49l-2.225-1.737V6.773c0-0.197-0.077-0.382-0.217-0.521c-0.14-0.141-0.325-0.218-0.523-0.218
                h-0.805c-0.198,0-0.383,0.077-0.522,0.217c-0.141,0.14-0.218,0.325-0.218,0.522v6.59l3.109,2.416
                C14.122,15.898,14.316,15.953,14.512,15.929z"/>
            <path d="M4.471,21.344c1.766,1.423,3.891,2.313,6.144,2.577c2.256,0.26,4.526-0.119,6.571-1.099
                c2.047-0.982,3.765-2.516,4.973-4.436c1.207-1.919,1.843-4.133,1.84-6.403c-0.005-2.357-0.694-4.64-1.992-6.603
                c-1.301-1.965-3.134-3.491-5.299-4.415c-2.164-0.924-4.534-1.192-6.852-0.769C7.539,0.615,5.413,1.697,3.71,3.324L3.38,3.64
                L0.575,0.834C0.53,0.788,0.468,0.755,0.403,0.741C0.336,0.729,0.27,0.735,0.209,0.761C0.148,0.786,0.095,0.829,0.058,0.885
                C0.021,0.94,0.001,1.006,0.001,1.072v7.309c0,0.09,0.035,0.174,0.098,0.237c0.065,0.065,0.149,0.1,0.239,0.1h7.307
                c0.067,0,0.132-0.02,0.187-0.057c0.056-0.037,0.099-0.09,0.124-0.151c0.026-0.062,0.033-0.129,0.02-0.195
                C7.962,8.251,7.931,8.19,7.884,8.145L4.992,5.251l0.351-0.33c1.359-1.277,3.047-2.133,4.881-2.474
                c1.83-0.34,3.716-0.15,5.444,0.555s3.208,1.883,4.281,3.409c1.073,1.525,1.682,3.317,1.761,5.18c0.078,1.864-0.377,3.7-1.318,5.312
                c-0.941,1.61-2.316,2.91-3.98,3.757c-1.66,0.846-3.523,1.196-5.376,1.012c-1.857-0.186-3.611-0.896-5.072-2.055
                c-0.129-0.102-0.29-0.157-0.456-0.157c-0.015,0-0.03,0-0.046,0.002c-0.181,0.012-0.352,0.088-0.479,0.216l-0.568,0.568
                c-0.072,0.073-0.132,0.163-0.168,0.259c-0.037,0.096-0.053,0.199-0.047,0.301c0.005,0.105,0.031,0.205,0.078,0.297
                C4.325,21.198,4.391,21.28,4.471,21.344z"/>
            </g>
        </SvgIcon>;
    }
}
